import ko from '@tko/build.knockout';
import viewModel from './kpi-panel.vm';
import templateMarkup from 'raw-loader!./kpi-panel.template.html';
    
    ko.components.register('assurance-kpi-panel', { template: templateMarkup, viewModel: viewModel });

